import functions from '../../../../../world/spa/libs/vuexFunctions';

export default {
    namespaced: true,
    state: {
        objs: []
    },
    getters: {
        ...functions.createDefaultGetters(),
        getByLicense: state => licenseId => {
            return state.objs.filter(e => e.license === licenseId);
        },
        getByPin: state => pin => {
            return state.objs.find(e => e.pin === pin);
        },
        getByUser: state => userId => {
            return state.objs.filter(e => e.administrator === userId);
        }
    },
    mutations: {
        ...functions.createDefaultMutations()
    },
    actions: {
        ...functions.createDefaultActionsWithStore()
    },
}